export class ServiceRespone{
    respObj : any;
    errorMex: String;
}